import * as React from 'react';
export const officeSvg = React.forwardRef(function officeSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M0 2.75A2.75 2.75 0 0 1 2.75 0H8a2.75 2.75 0 0 1 2.75 2.75V3a.75.75 0 0 1-1.5 0v-.25c0-.69-.56-1.25-1.25-1.25H2.75c-.69 0-1.25.56-1.25 1.25v11.5c0 .138.112.25.25.25h2.5a.75.75 0 0 1 0 1.5h-2.5A1.75 1.75 0 0 1 0 14.25V2.75Zm10.852 3.114a.75.75 0 0 1 .796 0l4 2.5A.75.75 0 0 1 16 9v5.25A1.75 1.75 0 0 1 14.25 16h-6a1.75 1.75 0 0 1-1.75-1.75V9a.75.75 0 0 1 .353-.636l4-2.5ZM8 9.416v4.834c0 .138.112.25.25.25h2.25V13a.75.75 0 0 1 1.5 0v1.5h2.25a.25.25 0 0 0 .25-.25V9.416l-3.25-2.032L8 9.416Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M3 4.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0ZM3 8a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm3-3.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm-3 7a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z',
    }),
  );
});
officeSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var office = {
  category: 'icon',
  colorable: true,
  name: 'office',
  svg: officeSvg,
};
